import { Tag } from 'primereact/tag';
import React from 'react';

interface CustomTagProps {
  text: string;
  width?: string;
  severity?: 'success' | 'warning' | 'danger' | 'info';
}

export const CustomTag: React.FC<CustomTagProps> = ({
  text,
  width,
  severity = 'info',
}) => {
  const getCustomStyle = (severity: string) => {
    const styleMap = {
      success: {
        backgroundColor: '#F0F7FF',
        color: '#0066CC',
        border: 'none',
        padding: '0.25rem 0.5rem',
        borderRadius: '4px',
        fontWeight: '400',
        fontSize: '0.875rem',
      },
      warning: {
        backgroundColor: '#FFF8F0',
        color: '#CC7700',
        border: 'none',
        padding: '0.25rem 0.5rem',
        borderRadius: '4px',
        fontWeight: '400',
        fontSize: '0.875rem',
      },
      danger: {
        backgroundColor: '#FFF0F0',
        color: '#CC0000',
        border: 'none',
        padding: '0.25rem 0.5rem',
        borderRadius: '4px',
        fontWeight: '400',
        fontSize: '0.875rem',
      },
      info: {
        backgroundColor: '#F0F7FF',
        color: '#0066CC',
        border: 'none',
        padding: '0.25rem 0.5rem',
        borderRadius: '4px',
        fontWeight: '400',
        fontSize: '0.875rem',
      },
    };
    return { ...styleMap[severity], width };
  };

  return (
    <Tag value={text} severity={severity} style={getCustomStyle(severity)} />
  );
};
